export default __webpack_public_path__ + "static/sausage-wide-06906ae758e6220d1c58803deb45878c.jpg";